module.exports = __webpack_public_path__ + "static/media/contele_cameras.5d6d3de1.png";